import React from 'react';
import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface Props {
    title: string;
    code: string;
    copied: boolean;
    onCopy: () => void;
}

const CodeSnippet: React.FC<Props> = ({
    title,
    code,
    copied,
    onCopy,
}) => {
    return (
        <Box
            sx={{
                overflow: 'hidden',
                borderRadius: 4,
                bgcolor: '#0F172A',
                mb: 3,
                border: '1px solid #1E293B',
                boxShadow:
                    '0 10px 30px rgba(15,23,42,.15)',
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    px: 2,
                    py: 1.5,
                    bgcolor: '#111827',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #1F2937',
                }}
            >
                <Box display="flex" gap={1}>
                    <Box
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: '#EF4444',
                        }}
                    />
                    <Box
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: '#F59E0B',
                        }}
                    />
                    <Box
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: '#10B981',
                        }}
                    />
                </Box>

                <Typography
                    variant="caption"
                    sx={{
                        color: '#9CA3AF',
                        fontWeight: 600,
                    }}
                >
                    {title}
                </Typography>

                <Button
                    size="small"
                    startIcon={
                        copied ? (
                            <CheckCircleOutlineIcon />
                        ) : (
                            <ContentCopyIcon />
                        )
                    }
                    onClick={onCopy}
                    sx={{
                        color: '#fff',
                        textTransform: 'none',
                        minWidth: 90,
                    }}
                >
                    {copied ? 'Copied' : 'Copy'}
                </Button>
            </Box>

            {/* Code */}
            <Box
                component="pre"
                sx={{
                    p: 3,
                    color: '#E5E7EB',
                    fontSize: '0.8rem',
                    overflowX: 'auto',
                    m: 0,
                    lineHeight: 1.7,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontFamily:
                        'SFMono-Regular,Consolas,Monaco,monospace',
                }}
            >
                {code}
            </Box>
        </Box>
    );
};

export default CodeSnippet;